import {Component, OnInit, Inject} from 'ng-metadata/core';
import { ResearchAssistantService } from "./researchAssistant.service";
import {getVid} from '../appConfig/appConfigForward';
import {STATE_NAMES} from "../primoExplore/primoExploreStates.module";
import {isBrowserSafari} from "../infra/browserSniffer";


@Component({
    selector: 'prm-research-assistant-sidebar',
    templateUrl: 'components/researchAssistant/research-assistant-sidebar.html'
})

export class PrmResearchAssistantSidebar implements OnInit{

    private availabilityLineIcons: Object[];
    private apiParams: string="";
    private showComponent: boolean = false;
    private vid = getVid();
    private timeoutPromise;
    private mainSearchField: string ="";
    private RESEARCH_ASSISTANT_STATE = STATE_NAMES.RESEARCH_ASSISTANT;

    constructor(@Inject('I18nService') private i18nService,
                private researchAssistantService: ResearchAssistantService,
                @Inject('actionIcons') public actionIcons,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                @Inject('availabilityLineIcons') availabilityLineIcons) {
        this.apiParams = this.createApiParams();
        this.availabilityLineIcons = availabilityLineIcons;
    }

    ngOnInit() {
        this.showComponent=true;
    }

    private createApiParams() {
        return JSON.stringify({vid:this.researchAssistantService.getVid(),lang:this.researchAssistantService.getLang()});
    };
    public initResearcher(){

    }

    get researchAssistantParams() {
        console.log("this.mainSearchField:"+this.mainSearchField);
        return {vid: this.vid, lang: this.$translate.use(), query:this.mainSearchField};
    }

    public closeResearchAssistantButton() {
        const toggleRaButton = document.getElementById('toggleRaButton');
        const toggleRaWidgetCont = document.getElementById('toggleRaWidgetCont');
        toggleRaWidgetCont.classList.remove('open');
        toggleRaButton.style.display = 'flex'; // Show toggleRaButton when toggleRaWidgetCont is closed
        toggleRaWidgetCont.setAttribute('aria-hidden', 'true');
        toggleRaButton.setAttribute('aria-expanded', 'false');
        toggleRaButton.focus();
    }
    
    public openResearchAssistant() {
        this.researchAssistantService.cameFrom = 'RESEARCH_ASSISTANT_WIDGET';
    }

    public isSafariBrowse() {
        return isBrowserSafari();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/researchAssistant/researchAssistantSidebar.directive.ts